module.exports = __webpack_public_path__ + "img/终端成功.319bab15.png";